import request from '@/utils/request'

//电商合集列表
export function getCollectionList(data) {
    return request({
        url: '/backend/ProductCollection/getMallCollectionList',
        method: 'post',
        data: data
    })
}

//创建电商合集
export function createCollection(data) {
    return request({
        url: '/backend/ProductCollection/createMallCollection',
        method: 'post',
        data: data
    })
}

//获取单个合集信息
export function getCollectionInfo(data) {
    return request({
        url: '/backend/ProductCollection/getCollectionInfo',
        method: 'post',
        data: data
    })
}



//获取关联商品列表
export function collectionProductList(data) {
    return request({
        url: '/backend/ProductCollection/getCollectionProductList',
        method: 'post',
        data: data
    })
}

//获取合集关联商品单个信息
export function getProductRelationInfo(data) {
    return request({
        url: '/backend/ProductCollection/getProductRelationInfo',
        method: 'post',
        data: data
    })
}

//电商合集商品编辑新增
export function updateProductRelationInfo(data) {
    return request({
        url: '/backend/ProductCollection/updateProductRelationInfo',
        method: 'post',
        data: data
    })
}

//电商合集商品修改排序
export function updateProductRelationSort(data) {
    return request({
        url: '/backend/ProductCollection/updateProductRelationSort',
        method: 'post',
        data: data
    })
}
//电商合集商品上下架
export function updateProductRelationOnline(data) {
    return request({
        url: '/backend/ProductCollection/updateProductRelationOnline',
        method: 'post',
        data: data
    })
}

//电商合集商品删除
export function deleteProductRelationInfo(data) {
    return request({
        url: '/backend/ProductCollection/deleteProductRelationInfo',
        method: 'post',
        data: data
    })
}

//电商商品删除
export function activityDeleteProduct(data) {
    return request({
        url: '/backend/ProductActivity/activityDeleteProduct',
        method: 'post',
        data: data
    })
}

//电商活动订单列表
export function activityOrderList(data) {
    return request({
        url: '/backend/ProductActivity/activityOrderList',
        method: 'post',
        data: data
    })
}

//获取sku列表
export function getSkuList(data){
    return request({
        url: '/backend/ProductActivity/getSkuList',
        method: 'post',
        data: data
    })
}

//获取冲突商品列表
export function getConflictActivity(data){
    return request({
        url: '/backend/ProductActivity/getConflictActivity',
        method: 'post',
        data: data
    })
}
